// extracted by mini-css-extract-plugin
module.exports = {"optionDetails":"PlayKitDetailsHeaderTreatment_optionDetails__Iga_a"};